import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'offer-inprogress',
  styleUrl: 'offer-inprogress.css',
})
export class OfferInProgress {
  @Prop() prospectId: string = '';
  @Prop() email: string = '';
  @Prop() zipCode: string = '';
  @Prop() vehicleShortDescription: string = '';
  @Prop() inProgressBtnText: string = '';
  @Prop() whenReviewVehicleDetailsClicked: (evt: MouseEvent) => void = () => {};
  @Prop() onFireDREvent: (buttonLabel?: string) => void = () => {};

  render() {
    const { email, zipCode, vehicleShortDescription, inProgressBtnText, prospectId } = this;
    return (
      <Host>
        <h2 class="mb-4">Your Offer is in progress but unexpectedly delayed. We'll email it to you as soon as it’s available.</h2>
        <div class="mb-6">Thank you for your patience.</div>
        <div class="text-center md:text-left mb-6">
          <div class="font-bold">{vehicleShortDescription}</div>
          <div>
            <a href="#" class="no-underline" onClick={(evt) => this.whenReviewVehicleDetailsClicked(evt)}>
              Review vehicle details
            </a>
          </div>
        </div>
        <div class="text-center md:text-left text-xs mb-8">
          <div>Offer ID: {prospectId}</div>
          {email && <div>Email: {email}</div>}
          <div>ZIP Code: {zipCode}</div>
        </div>
        <p class="xs:text-center md:text-left">
          Questions about the Instant Cash Offer program? <span class="font-bold">Call (866) 559-5268</span>
        </p>
        {!!inProgressBtnText && (
          <div class="flex xs:justify-center md:justify-start w-full xs:pb-9 md:pb-6">
            <ico-button buttonStyle="final-action" label={inProgressBtnText} whenClicked={() => this.onFireDREvent(inProgressBtnText)} />
          </div>
        )}
      </Host>
    );
  }
}
